import React from "react"

import { graphql } from "gatsby"
import PropTypes from "prop-types"

import CopyContainer from "../../components/atoms/copy-container"
import Heading from "../../components/atoms/heading"
import Wrapper from "../../components/atoms/wrapper"
import Seo from "../../components/head"
import Layout from "../../components/layout"
import ContestPartners from "../../helpers/contest-partners"
import rulesWithVars, { dateString } from "../../helpers/portable-text-mapping"

const ContestRulesPage = ({ data, pageContext }) => {
  const contestObjectMapping = {
    partners: ContestPartners(
      data.allSanityDictionary.nodes.find(
        (item) => item.key.current === "title"
      )?.value,
      data.sanityContest.partners,
      "name"
    ),
    start_date: dateString(data.sanityContest.start_date),
    end_date: dateString(data.sanityContest.end_date),
    winner_date: dateString(data.sanityContest.winner_date),
    name: data.sanityContest.name,
    slug: data.sanityContest.slug.current,
    partner_terms: ContestPartners(null, data.sanityContest.partners, "url"),
    number_of_prizes: data.sanityContest.number_of_prizes,
    description_of_prizes: data.sanityContest.description_of_prizes,
  }
  const baseRules = data.sanityContest.base_rules
    ? rulesWithVars(pageContext.baseRules, contestObjectMapping)
    : null

  return (
    <Layout>
      <Wrapper container>
        <CopyContainer>
          <Heading>{`${data.sanityContest.name} ${
            data.allSanityDictionary.nodes.find(
              (item) => item.key.current === "rules"
            )?.value
          }`}</Heading>
          {data.sanityContest.base_rules ? (
            <CopyContainer content={baseRules} />
          ) : (
            ""
          )}
          <CopyContainer content={data.sanityContest._rawCustomRules} />
        </CopyContainer>
      </Wrapper>
    </Layout>
  )
}

ContestRulesPage.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
}

export default ContestRulesPage

const HeadComponent = ({ data, location }) => (
  <Seo
    title={`${data.sanityContest.name} ${
      data.allSanityDictionary.nodes.find(
        (item) => item.key.current === "rules"
      )?.value
    }`}
    path={location.pathname}
  />
)

HeadComponent.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
}

export const Head = HeadComponent

export const contestRulesQuery = graphql`
  query contestRulesQuery($id: String!) {
    allSanityDictionary {
      nodes {
        key {
          current
        }
        value
      }
    }
    sanityContest(id: { eq: $id }) {
      name
      slug {
        current
      }
      base_rules
      start_date
      end_date
      winner_date
      number_of_prizes
      description_of_prizes
      partners {
        type
        privacy_url
        partner {
          name
        }
      }
      _rawCustomRules
    }
  }
`
